   
let productCarousel = document.querySelector(".js-product-carousel");
let productColumn   = productCarousel.dataset.column;
let productLoop     = productCarousel.dataset.loop;

if(Number(productLoop) < Number(productColumn)) {
    var loop = false;
} else {
    var loop = true;
}

let init = false;
let swiper_products;

function swiperProduct() {
    if (!init) {
      init = true;
        let productSwiper = new Swiper(".js-product-carousel", {
            slidesPerView: 1.3,
            spaceBetween: 20,
            loop: loop,
            freeMode: false,
            preventClicks :true,
            a11y: false,
            slidesOffsetBefore: 20,
            navigation: {
                nextEl: ".swiper-button-next.js-button-next",
                prevEl: ".swiper-button-prev.js-button-prev",
            },
            pagination: {
                el: ".product-swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                575: {
                    slidesPerView: productColumn - 2.3,
                    spaceBetween: 20,
                },
                750: {
                    slidesPerView: productColumn - 1.3,
                    spaceBetween: 20,
                },
                990: {
                    slidesPerView: productColumn -0.3,
                    spaceBetween: 20,
                },
            },
        });
    }

}
swiperProduct();
window.addEventListener("resize", swiperProduct);